"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyWebChatButtonWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var StickyWebChatButtonWidget = /** @class */ (function (_super) {
    __extends(StickyWebChatButtonWidget, _super);
    function StickyWebChatButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadWebChatScript = function () {
            var brand = process.env.REACT_APP_BRAND_NAME;
            var contentGuruDisabled = String(process.env.REACT_APP_CONTENT_GURU_CHAT_DISABLED).toLowerCase() === "true";
            if (brand) {
                var scriptPath = contentGuruDisabled ? "/genesys/genesys-web-chat-script-".concat(brand, ".js") : "/web-chat-script-".concat(brand, ".js");
                // Check if the script is already loaded
                if (!document.querySelector("script[src=\"".concat(scriptPath, "\"]"))) {
                    _this.webChatScript = document.createElement("script");
                    _this.webChatScript.src = scriptPath;
                    _this.webChatScript.async = true;
                    _this.webChatScript.onload = function () {
                        if (typeof window.WebChat === "function") {
                            if (contentGuruDisabled) {
                                window.WebChat("init");
                            }
                            window.WebChat("subscribe", "MessagingService.ready", function () {
                                window.WebChat("subscribe", "MessagingService.sendingMessage", function () {
                                    _this.pushEventToAdobeDataLayer("botMessageSent");
                                });
                            });
                        }
                        else {
                            var providerName = contentGuruDisabled ? "Genesys" : "ContentGuru";
                            console.error("".concat(providerName, " is not defined in the local script."));
                        }
                    };
                    document.head.appendChild(_this.webChatScript);
                }
            }
            else {
                console.log("Web-chat script not available");
            }
        };
        _this.handleBackNavigation = function (event) {
            // Reload the entire page
            if (window.location.href.includes("/products")) {
                window.location.reload();
            }
        };
        return _this;
    }
    StickyWebChatButtonWidget.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
        this.loadWebChatScript();
    };
    StickyWebChatButtonWidget.prototype.componentWillUnmount = function () {
        var _this = this;
        window.removeEventListener('popstate', function (ev) { return _this.handleBackNavigation(ev); });
    };
    StickyWebChatButtonWidget.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    StickyWebChatButtonWidget.prototype.pushEventToAdobeDataLayer = function (eventName) {
        var key = 'adobeDataLayer';
        window[key] = window[key] || [];
        window[key].push({
            event: eventName
        });
    };
    return StickyWebChatButtonWidget;
}(plugin_journey_1.WidgetBase));
exports.StickyWebChatButtonWidget = StickyWebChatButtonWidget;
//# sourceMappingURL=StickyWebChatButtonWidget.js.map